/** Shared validation helpers for ops forms. */

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Saudi mobile: +9665XXXXXXXX, 9665XXXXXXXX, or 05XXXXXXXX */
export const SAUDI_PHONE_REGEX = /^(\+9665|9665|05)[0-9]{8}$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test((value || '').trim());
}

export function isValidSaudiPhone(value: string): boolean {
  const normalized = (value || '').trim().replace(/\s/g, '');
  return normalized ? SAUDI_PHONE_REGEX.test(normalized) : false;
}
